import styled from 'styled-components';

// styles
export const Wrapper = styled.div`
    width: 100%;
    margin: auto;
    background: white;
    padding-bottom: 160px;
    .header {
        width: auto;
        height: 700px;
        background-image: url('/nextasset/images/landing/background.jpg');
        background-size: cover;
        background-repeat: no-repeat;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        ${p => p.webConfig.dir === 'ltr' && `
            direction: rtl;
        `}
    }
    .header-content {
        width: 400px;
        @media (max-width: 600px) {
            width: 100%;
        }
    }
    h2 {
        color: black;
        font-size: 23px;
        font-weight: 700;
        line-height: 46px;
        text-align: justify;
        @media (max-width: 900px) {
            text-align: center;
        }
        @media (max-width: 600px) {
            font-size: 20px;
            line-height: 40px;
        }
    }
    .button {
        background: #201E67;
        border-radius: 8px;
        font-size: 16px;
        font-weight: 700;
        width: 100%;
        height: 56px;
        @media (max-width: 600px) {
            font-size: 15px;
            height: 54px;
        }
    }
    .desc {
        color: black;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        line-height: 32px;
        margin-top: 5px;
        @media (max-width: 600px) {
            font-size: 15px;
            line-height: 30px;
            margin-top: 10px;
            text-align: justify;
        }
    }
    .download-box {
        display: flex;
        flex-direction: column;
        gap: 20px;
        justify-content: center;
        align-items: center;
        width: 450px;
        @media (max-width: 600px) {
            width: 100%;
        }
    }
    .column-flex {
        display: flex;
        flex-direction: column;
        gap: 20px;
        margin: auto;
        margin-top: 80px;
        justify-content: center;
        align-items: center;
        width: 550px;
        @media (max-width: 600px) {
            width: 100%;
            margin-top: 80px;
        }
    }
    .dl-items {
        gap: 15px;
        margin-top: 30px;
        width: 100%;
    }
    .row-flex {
        display: flex;
        flex-direction: row;
        gap: 20px;
        justify-content: center;
        width: 100%;
        margin-top: 20px;
        @media (max-width: 600px) {
            flex-direction: column;
            gap: 10px;
        }
    }
    .main-title {
        color: #201E67;
        font-size: 25px;
        font-weight: 1000;
        @media (max-width: 900px) {
            font-size: 24px;
            margin-bottom: -10px;
        }
    }
    .title {
        color: #61788E;
        font-size: 18px;
        font-weight: 600;
        border-bottom: 1px solid #61788E;
        width: 100%;
        padding-bottom: 10px;
        text-align: center;
        @media (max-width: 900px) {
            font-size: 16px;
        }
    }
    .dl-item {
        color: black;
        font-size: 16px;
        font-weight: 600;
        display: flex;
        flex-direction: row;
        justify-content: center;
        gap: 10px;
        align-items: center;
        background: #201E67;
        border-radius: 16px;
        padding: 13px 0;
        width: 350px;
        cursor: pointer;
        color: white;
        text-decoration: none;
        @media (max-width: 900px) {
            font-size: 15px;
        }
        @media (max-width: 600px) {
            width: 100%;
            padding: 15px 0;
        }
    }
    .text-content {
        height: auto;
        width: 700px;
        margin: auto;
        margin-top: 120px;
        @media (max-width: 900px) {
          width: 100%;
          margin-top: 100px;
        }
    }
    .feature-title {
        color: black;
        font-size: 19px;
        font-weight: 800;
        @media (max-width: 900px) {
            font-size: 18px;
        }
    }
    .mockup {
        border-radius: 16px;
        margin-left: 20px;
        ${p => p.webConfig.dir === 'ltr' && `
            margin-right: 20px;
            margin-left: 0px;
        `}
    }
    .carousel {
        width: 100%;
        margin-top: 120px;
        @media (max-width: 900px) {
            margin-top: 100px;
        }
    }
`